module.exports = {
  apiUrl: process.env.REACT_APP_API_URL,
  apiKey: process.env.REACT_APP_API_KEY_NURTURE_THREAPY,
  tenant: 'nurture-therapy',
  messageLimit: null,
  logo: 'girl-headphones.png',
  messageFlagEnabled: true,
  pageTitle: 'Ema - Nurture Therapy',
};
